import request from "@/utils/request";

/**
 * AI引擎列表
 * 
 * 请求Body参数
 * page    是  string  页码
 * size    是  string  每页数量
 * account 否  string  用户名（筛选）
 * model   否  string  模型名（筛选）
 * status  否  string  1 启用 2 禁用（筛选）

成功返回示例
{
  "code": 200,
  "msg": "ok",
  "data": {
    "current_page": 1,
    "total_page": 1,
    "total": 1,
    "lists": [
      {
        "id": 1,
        "name": "",
        "member_id": 14,
        "member_account": "test002",
        "model": "deepseek-v3.1",
        "api_key": "api_keyapi_key",
        "base_url": "base_urlbase_url",
        "status": 1,
        "update_time": "2025-11-04 17:11:55",
        "create_time": "2025-11-04 17:11:55"
      }
    ]
  },
  "t": 1762247525
}

 */
export function engines_list(data) {
  return request({ url: "/api/engines/list", method: "post", data });
}

/**
 * AI引擎新增编辑
 * 
 * 请求Body参数
 * eid       否  string  引擎ID（编辑必传，新增可不传或留空）
 * model     是  string  模型名，如 deepseek-v3.1
 * api_key   是  string  API Key
 * base_url  是  string  Base URL
 * status    是  string  1 启用 2 禁用

成功返回示例
{
  "code": 200,
  "msg": "ok",
  "data": ""
}

 */
export function engines_edit(data) {
  return request({ url: "/api/engines/edit", method: "post", data });
}

/**
 * AI引擎删除
 * 
 * 请求Body参数
 * eid  15  是  string  引擎ID

成功返回示例
{
  "code": 200,
  "msg": "ok",
  "data": ""
}

*/

export function engines_del(data) {
  return request({ url: "/api/engines/del", method: "post", data });
}

/**
 * AI引擎列表-搜索编辑使用
 * 
 * 请求Body参数
 * 无
 * 
 * 成功返回示例
 * {
  "code": 200,
  "msg": "ok",
  "data": [
    {
      "id": 1,
      "name": "",
      "model": "deepseek-v3.1"
    }
  ],
  "t": 1762247587
}

*/
export function engines_slist(data) {
  return request({ url: "/api/engines/slist", method: "post", data });
}

/**
 * 交易所列表-搜索编辑使用
 * 
 * 请求Body参数
 * 无
 * 
 * 成功返回示例
 * {
  "code": 200,
  "msg": "ok",
  "data": [
    {
      "id": "1",
      "name": "币安(Binance)",
      "status": 1
    },
    {
      "id": "2",
      "name": "欧易(OKX)",
      "status": 1
    }
  ],
  "t": 1762248142
}

 */
export function exchanges_ailists(data) {
  return request({ url: "/api/exchanges/ailists", method: "post", data });
}

/**
 * 交易对列表-搜索编辑使用
 * 
 * 请求Body参数
 * exchange_id  是  string  交易所ID
 * 
 * 成功返回示例
 * {
  "code": 200,
  "msg": "ok",
  "data": [
    {
      "id": 1,
      "pair": "BTC/USDT",
      "status": 1
    },
    {
      "id": 2,
      "pair": "ETH/USDT",
      "status": 1
    },
    {
      "id": 3,
      "pair": "BNB/USDT",
      "status": 1
    },
    {
      "id": 4,
      "pair": "SOL/USDT",
      "status": 1
    }
  ],
  "t": 1762249177
}

 */
export function bots_spair(data) {
  return request({ url: "/api/bots/spair", method: "post", data });
}

/**
 * 机器人列表
 * 
 * 请求Body参数
page		是	string	无
size	1	是	string	止损 单位USTD没有小数
name		是	string	名称
exchange_id		是	string	交易所id 
ai_engine_id		是	string	AI引擎ID
pair		是	string	交易对 BTC/USTD
kline		是	string	数据周期 单位分钟 1,2,3
remark		是	string	备注
 * 
 * 成功返回示例
 * {
  "code": 200,
  "msg": "ok",
  "data": {
    "current_page": 1,
    "total_page": 1,
    "total": 1,
    "lists": [
      {
        "id": 1,
        "member_id": 14,
        "member_account": "test002",
        "exchange_id": 1,
        "ai_engine_id": 1,
        "name": "BBBBBBBB",
        "pair": "BTC/USTD",
        "kline": "1",
        "stop_loss": 0,
        "take_profit": 0,
        "max_daily_loss": 0,
        "status": 0,
        "profit": "0.0000",
        "trades": 0,
        "notifications": "",
        "remark": "",
        "create_time": "2025-11-04 17:53:05",
        "update_time": "2025-11-04 17:53:05"
      }
    ]
  },
  "t": 1762250181
}


 */
export function bots_list(data) {
  return request({ url: "/api/bots/list", method: "post", data });
}

/**
 * 机器人新增编辑
 * 
 * 请求Body参数
 * bid		是	string	无
name	BBBBBBBB	是	string	名称
exchange_id	1	是	string	交易所id
ai_engine_id	1	是	string	AI引擎ID
pair	BTC/USTD	是	string	交易对 BTC/USTD
kline	1	是	string	数据周期 单位分钟 1,2,3
stop_loss	10	是	string	止损 单位USTD没有小数
stop_loss		是	string	止盈 单位USTD没有小数
max_daily_loss		是	string	每日最大亏损 单位USTD没有小数
remark	remark	否	string	备注 可为空
 * 
 * 成功返回示例
 * {
  "code": 200,
  "msg": "ok",
  "data": ""
}

 */
export function bots_edit(data) {
  return request({ url: "/api/bots/edit", method: "post", data });
}

/**
 * 机器人删除
 * 
 * 请求Body参数
 * bid  1  是  string  机器人ID
 * 
 * 成功返回示例
 * {
  "code": 200,
  "msg": "ok",
  "data": ""
}

 */
export function bots_del(data) {
  return request({ url: "/api/bots/del", method: "post", data });
}

/**
 * 机器人列表-搜索编辑使用
 * 
 * 请求Body参数
 * id  是  string  机器人ID
 * name  是  string  名称
 * status  是  string  状态 1 启用 2 禁用
 * 
 * 成功返回示例
 * {
  "code": 200,
  "msg": "ok",
  "data": [
    {
      "id": 1,
      "name": "BBBBBBBB",
      "status": 1
    },
    {
      "id": 2,
      "name": "CCCCCCC",
      "status": 1
    }
  ],
  "t": 1762249177
}

 */
export function bots_slist(data) {
  return request({ url: "/api/bots/sbots", method: "post", data });
}


 /**
  * 清空机器人收益
  * 
  * 请求Body参数
  * bot_id  是  string  机器人ID
  * 
  * 成功返回示例
  * {
  *   "code": 200,
  *   "msg": "ok",
  *   "data": ""
  * }
  */
 export function bots_clear(data) {
  return request({ url: "/api/bots/clear", method: "post", data });
}

/**
 * 登录
 * 
 * 请求Body参数
account	test002	是	string	无
password	123456	是	string	无
os	windows	是	string	windows/mac/linux/android/ios/
mac		否	string	mac地址 可为空
 * 
 * 成功返回示例
 * {
  "code": 200,
  "msg": "login_ok",
  "data": {
    "server": "198.165.12.13",
    "port": 1234,
    "member_id": 14,
    "account": "test002",
    "token": "395b57be2650f2d3c4ff74e5194ee09d",
    "uuid": "01f1a584-e8b9-ac66-09aa-9ed91dfa2ec1"
  },
  "t": 1760668146
}

 */
export function login(data) {
  return request({ url: "/api/login/login", method: "post", data });
}

/**
 * 登出
 * 
 * 请求Body参数
 * 无
 * 
 * 成功返回示例
 * {
  "code": 200,
  "msg": "ok",
  "data": ""
}
 */
export function logout(data) {
  return request({ url: "/api/login/out", method: "post", data });
}

/**
 * 忘记密码
 * 
 * 请求Body参数
 * account	1234@qq.com	是	string	邮箱
repass	123456	是	string	新密码
email_code	123456	是	string	邮件验证码
 * 
 * 成功返回示例
 * {
  "code": 200,
  "msg": "ok",
  "data": ""
}

 */
export function forget(data) {
  return request({ url: "/api/login/forget", method: "post", data });
}

/**
 * 邮箱发送验证码
 * 
 * 请求Body参数
 * email	1231@qq.com	否	string	邮箱
 * 
 * 成功返回示例
 * {
  "code": 200,
  "msg": "ok",
  "data": ""
}

 */
export function getSms(data) {
  return request({ url: "/api/login/email", method: "post", data });
}

/**
 * 登陆后修改密码
 * 
 * 请求Body参数
 * old_pwd	123456	否	string	无
new_pwd	1234567	否	string	无
 * 
 * 成功返回示例
 *{
  "code": 200,
  "msg": "ok",
  "data": ""
}

 */
export function change_pass(data) {
  return request({ url: "/api/login/pass", method: "post", data });
}

/**
 * 注册
 * 
 * 请求Body参数
 * account	12aa@qq.com	是	string	邮箱 会真的发邮件
    password	12345555	是	string	密码
    os	windows	是	string	windows/android/ios/
    mac		否	string	mac地址 可不填
 * 
 * 成功返回示例
 * {
  "code": 200,
  "msg": "register_ok",
  "data": {
    "member_id": 106,
    "account": "12aa@qq.com",
    "token": "e609bd0b10886df7de64367cc355a73d",
    "uuid": "be2b1c23-8465-c647-b0c9-267f3fadc06e"
  },
  "t": 1760510502
}

 */
export function regist(data) {
  return request({ url: "/api/login/register", method: "post", data });
}

/**
 * 用户登录后修改邮箱
 * 
 * 请求Body参数
 * email	770735663@qq.com	是	string	邮箱 如果用户名是邮箱的话 会一起更改
email_code	123456	是	string	无
 * 
 * 成功返回示例
 * {
  "code": 200,
  "msg": "ok",
  "data": ""
}

 */
export function change_email(data) {
  return request({ url: "/api/login/change_email", method: "post", data });
}

/**
 * 基础交易所列表-搜索编辑使用
 * 
 * 请求Body参数
 * 无
 * 
 * 成功返回示例
 * {
  "code": 200,
  "msg": "ok",
  "data": [
    {
      "id": 1,
      "name": "币安(Biance)",
      "icon": "biance.png",
      "status": 1
    },
    {
      "id": 2,
      "name": "欧易(okx)",
      "icon": "okex.png",
      "status": 1
    }
  ],
  "t": 1762307735
}

 */
export function exchanges_slist(data) {
  return request({ url: "/api/exchanges/slist", method: "post", data });
}

/**
 * 基础交易所列表
 * 
 * 请求Body参数
 * page		是	string	无
size	1	是	string	无
account		是	string	用户名
model		是	string	模型名
status		是	string	1 启用 2禁用
 * 
 * 成功返回示例
 * {
  "code": 200,
  "msg": "ok",
  "data": {
    "current_page": 1,
    "total_page": 1,
    "total": 1,
    "lists": [
      {
        "id": 1,
        "name": "",
        "member_id": 14,
        "member_account": "test002",
        "model": "deepseek-v3.1",
        "api_key": "api_keyapi_key",
        "base_url": "base_urlbase_url",
        "status": 1,
        "update_time": "2025-11-04 17:11:55",
        "create_time": "2025-11-04 17:11:55"
      }
    ]
  },
  "t": 1762247525
}

 */
export function exchanges_list(data) {
  return request({ url: "/api/exchanges/list", method: "post", data });
}

/**
 * 基础交易所新增编辑
 * 
 * 请求Body参数
 * aid		是	string	无
exchange_id	1	是	string	基础交易所列表ID
api_key	api_keyapi_key	是	string	Access Key / API Key
secret_key	secret_keysecret_key	是	string	Base URL
passphrase		是	string	okx才有 选填
status	1	是	string	1 启用 2禁用
remark	remarkremark	是	string	备注
 * 
 * 成功返回示例
 * {
  "code": 200,
  "msg": "ok",
  "data": ""
}

 */
export function exchanges_edit(data) {
  return request({ url: "/api/exchanges/edit", method: "post", data });
}

/**
 * 基础交易所删除
 * 
 * 请求Body参数
 * aid	15	是	string	无
 * 
 * 成功返回示例
 * {
  "code": 200,
  "msg": "ok",
  "data": ""
}

 */
export function exchanges_del(data) {
  return request({ url: "/api/exchanges/del", method: "post", data });
}

/**
 * 消息通知管理
 * 
 * 请求Body参数
 * page		是	string	无
size	1	是	string	无
ai_bot_id		是	string	交易机器人ID
signal		是	string	信号 买入BUY	卖出SELL	退出EXIT	持有HOLD
confidence		是	string	可信度 HIGH	MEDIUM	LOW 高	中	低
risk_level		是	string	风险等级 HIGH	MEDIUM	LOW 高	中	低
ct_start		是	string	Y-m-d
ct_end		是	string	Y-m-d
 * 
 * 成功返回示例
 * {
    "code": 200,
    "msg": "ok",
    "data": {
        "current_page": 1,
        "total_page": 1,
        "total": 2,
        "lists": [
            {
                "id": 4,
                "member_id": 109,
                "member_account": "test002",
                "ai_bot_id": 1,
                "signal": "EXIT",
                "reason": "简要分析理由（50字以内）",
                "detailed_analysis": "详细技术分析（100字以内）",
                "stop_loss": 10,
                "take_profit": 10,
                "confidence": "MEDIUM",
                "risk_level": "HIGH",
                "exit_reason": "如果是EXIT信号，说明为什么要提前离场（仅EXIT信号需要）",
                "create_time": "2025-11-05 11:27:51"
            },
            {
                "id": 3,
                "member_id": 109,
                "member_account": "test002",
                "ai_bot_id": 1,
                "signal": "BUY",
                "reason": "简要分析理由（50字以内）",
                "detailed_analysis": "详细技术分析（100字以内）",
                "stop_loss": 10,
                "take_profit": 100,
                "confidence": "HIGH",
                "risk_level": "LOW",
                "exit_reason": "",
                "create_time": "2025-11-05 11:27:51"
            }
        ]
    },
    "t": 1762331061
}
 * 
 */
export function signals_list(data) {
  return request({ url: "/api/signals/list", method: "post", data });
}


 /**
  * 清空机器人日志
  * 
  * 请求Body参数
  * ai_bot_id  是  string  机器人ID
  * 
  * 成功返回示例
  * {
  *   "code": 200,
  *   "msg": "ok",
  *   "data": ""
  * }
  */
 export function signals_clear(data) {
  return request({ url: "/api/signals/clear", method: "post", data });
}

 /**
  * 消息通知列表
  * 
  * 请求Body参数
  * page		是	string	无
  size	1	是	string	无
  name		是	string	名称
  type		是	string	1 Telegram 2 Dingding
  status		是	string	1 启用 2 禁用
  * 
  * 成功返回示例  
  * 
  *{
    "code": 200,
    "msg": "ok",
    "data": {
        "current_page": 1,
        "total_page": 1,
        "total": 1,
        "lists": [
            {
                "id": 1,
                "name": "tg1",
                "type": 1,
                "chartid_secret": "aweq",
                "token_webhook": "3123",
                "status": 1,
                "create_time": "2025-11-10 17:06:02",
                "update_time": "2025-11-10 17:06:02"
            }
        ]
    },
    "t": 1762841050
}
  */
 export function notification_list(data) {
   return request({ url: "/api/notification/list", method: "post", data });
 }
 
 /**
  * 消息通知列表
  * 
  * 请求Body参数
  * id  是  string  通知ID
  name		是	string	名称
  type		是	string	1 Telegram 2 Dingding
  status		是	string	1 启用 2 禁用
  * 
  * 成功返回示例  
  * 
  *{
    "code": 200,
    "msg": "ok",
    "data": {
        "current_page": 1,
        "total_page": 1,
        "total": 1,
        "lists": [
            {
                "id": 1,
               
                "name": "tg1",
                "type": 1,
                "status": 1
            }
        ]
    },
    "t": 1762841050
}
  */
 export function notification_slist(data) {
  return request({ url: "/api/notification/slist", method: "post", data });
}

 /**
  * 通知配置新增编辑
  * 
  * 请求Body参数
  * nid             否  string  通知ID（编辑必传，新增可不传或留空）
  * name            是  string  名称
  * type            是  string  类型 1 Telegram 2 Dingding
  * chartid_secret  是  string  如果type=1是ChatID，如果type=2是加签密钥
  * token_webhook   是  string  如果type=1是BotToken，如果type=2是WebhookUrl
  * status          是  string  状态 1 启用 2 禁用
  * 
  * 成功返回示例
  * {
  *   "code": 200,
  *   "msg": "ok",
  *   "data": ""
  * }
  */
 export function notification_edit(data) {
   return request({ url: "/api/notification/edit", method: "post", data });
 }

 /**
  * 通知配置删除
  * 
  * 请求Body参数
  * nid  是  string  通知ID
  * 
  * 成功返回示例
  * {
  *   "code": 200,
  *   "msg": "ok",
  *   "data": ""
  * }
  */
 export function notification_del(data) {
   return request({ url: "/api/notification/del", method: "post", data });
 }